'use client';

import React, { FC } from 'react';
import { Slide } from 'atoms/Carousel';
import { Slider } from 'molecules/Slider';
import { NavigationTypes } from 'molecules/Slider/NavigationButtons';
import { ProductTile } from 'organisms/ProductTile';
import { InView } from 'pages/ProductListing/InView';
import { useGTMItemListView } from 'modules/gtm/modules/sections/productList/hooks';
import { DESKTOP_WIDTH, SMALL_DESKTOP_WIDTH } from 'modules/mui/hooks';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import styles from './styles.module.css';

export const Recommendations: FC<{
  products: IAdaptedListProduct[];
}> = ({ products }) => {
  const { addProductToGTMList } = useGTMItemListView();

  return !products?.length ? null : (
    <Slider
      spaceBetween={10}
      pagination={{ enabled: true }}
      navigation={{ enabled: true }}
      navigationType={NavigationTypes.COMPACT}
      slidesPerView={2}
      slidesPerGroup={2}
      breakpoints={{
        [SMALL_DESKTOP_WIDTH]: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
        [DESKTOP_WIDTH]: {
          slidesPerView: 4,
        },
      }}
    >
      {products.map((product) => (
        <Slide key={product.id} className={styles.slide}>
          <InView
            onVisible={() => {
              addProductToGTMList(product);
            }}
            enable
          >
            <ProductTile product={product} />
          </InView>
        </Slide>
      ))}
    </Slider>
  );
};
